// TopicPage.jsx (v5)
import { useParams, useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import DOMPurify from "dompurify";
// Optional: wrap content area if this page is rendered standalone
// import styles from "./doc.module.css";

export default function TopicPage() {
  const { category, topic } = useParams();
  const history = useHistory();
  const [html, setHtml] = useState("");

  useEffect(() => {
    if (!category || !topic) return;
    const path = `/docs/${category}/${topic}.html`;
    fetch(path)
      .then(res => {
        if (!res.ok) throw new Error("Not found");
        return res.text();
      })
      .then(text => setHtml(DOMPurify.sanitize(text)))
      .catch(() => history.replace("/404"));
  }, [category, topic, history]);

  // If TopicPage is nested inside GuidesLayout, the layout's <main> already applies styles.content
  return <div dangerouslySetInnerHTML={{ __html: html }} />;
}